import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Socket } from "socket.io-client";
import { RootState } from "../..";

export type SocketConnectionStatus = "connected" | "disconnected";

interface Props {
  socket: Socket | any;
  executeConnectSocketEventWithReConnectUser: (() => void); // Function to be stored
  executeConnectSocketEventWithConnectUser: ((data:any) => void); // Function to be stored
  connectionStatus: SocketConnectionStatus;
}

const INITIAL_STATE: Props = {
  socket: null,
  executeConnectSocketEventWithReConnectUser: ()=>undefined,
  executeConnectSocketEventWithConnectUser: ()=>undefined,
  connectionStatus: "disconnected",
};

const SocketSlice = createSlice({
  name: "SocketSlice",
  initialState: INITIAL_STATE,
  reducers: {
    setSocketStatus(state, { payload }: PayloadAction<any>) {
      state.socket = payload;
    },

    removeSocketStatus() {
      return INITIAL_STATE;
    },

    setExecuteConnectSocketEventWithReConnectUser(state, { payload }: PayloadAction<() => void>) {
      state.executeConnectSocketEventWithReConnectUser = payload;
    },
    setExecuteConnectSocketEventWithConnectUser(state, { payload }: PayloadAction<() => void>) {
      state.executeConnectSocketEventWithConnectUser = payload;
    },
    setConnectionStatus(state, { payload }: PayloadAction<SocketConnectionStatus>) {
      state.connectionStatus = payload;
    },
  },
});

export default SocketSlice.reducer;

export const {
  removeSocketStatus,
  setSocketStatus,
  setExecuteConnectSocketEventWithReConnectUser,
  setExecuteConnectSocketEventWithConnectUser,
  setConnectionStatus,
} = SocketSlice.actions;

export const socketStatusStore = (state: RootState) =>
  state.botData.currrentSocketStatus;
